import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import * as AppContext from '../constants/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function getAppContext(state) {
  return state.app.appContext;
}
const coreTypeMap = {
  [AppContext.ADMIN_PREVIEW]: 'admin-preview',
  [AppContext.IN_APP]: 'app',
  [AppContext.PUBLIC]: 'public'
};
export function getAppContextCoreType(state) {
  return coreTypeMap[state.app.appContext];
}
function makeAppContextSelector(appContext) {
  return createSelector([getAppContext], _appContext => {
    return _appContext === appContext;
  });
}
export const getIsInApp = makeAppContextSelector(AppContext.IN_APP);
export const getIsPublicApp = makeAppContextSelector(AppContext.PUBLIC);
export const getIsAdminPreview = makeAppContextSelector(AppContext.ADMIN_PREVIEW);
export function PublicOnly({
  children
}) {
  const isPublicApp = useSelector(getIsPublicApp);
  return isPublicApp ? /*#__PURE__*/_jsx(Fragment, {
    children: children
  }) : null;
}